/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1BankIdImage202,
  DeleteApiV1BankIdImage401,
  DeleteApiV1BankIdImage404,
  DeleteApiV1BankIdImage500,
  DeleteApiV1BankIdImageMutationResponse,
  DeleteApiV1BankIdImagePathParams,
} from "../../types/bankImagemController/DeleteApiV1BankIdImage.ts";

export const deleteApiV1BankIdImagePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1BankIdImagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1BankIdImage202Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankIdImage202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1BankIdImage401Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankIdImage401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1BankIdImage404Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankIdImage404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1BankIdImage500Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankIdImage500>;

export const deleteApiV1BankIdImageMutationResponseSchema = z.lazy(
  () => deleteApiV1BankIdImage202Schema,
) as unknown as ToZod<DeleteApiV1BankIdImageMutationResponse>;
